import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { decode as base64_decode } from 'base-64';
import { constant } from '../../../Utils/constants';
import { Form, message, Select,Button } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';
import WorkOrderJobPlanesTask from './WorkOrderJobPlanesTask';

import {
  getDeviceList,
  getOrganisationsList,
  getSitesList,
  submitWorkOrder,
  getJobPlansList,
  // getJobPlanById,
  getLocationByAsset,
  getWorkTypes,
  getStatus,
  getWorkOrderById
} from '../../../Utils/FormCalls';

const { Option } = Select;

const WorkOrderDetails = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [, setOrganisationsList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [, setWorkTypesList] = useState([]);
  const [, setJobPlansList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [selectedJobPlan, setSelectedJobPlan] = useState(formObject.JobPlanName || '');
  const [noJobplan, setNoJobplan] = useState(false);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const workOrderRef = useRef();


  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      const deviceList = await getDeviceList();
      setDeviceList(deviceList);
      const organisationsList = await getOrganisationsList();
      setOrganisationsList(organisationsList);
      const sitesList = await getSitesList();
      let formObject = workOrderRef && workOrderRef.current && workOrderRef.current.getFieldsValue();
      formObject = {
        ...formObject,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      workOrderRef.current.setFieldsValue(formObject);
      setSitesList(sitesList);
      setFormObject(formObject);
      const jobPlansList = await getJobPlansList('Active');
      setJobPlansList(jobPlansList);
      const workTypes = await getWorkTypes();
      setWorkTypesList(workTypes);
      const statusList = await getStatus();
      setStatusList(statusList);
      if (formObject && formObject.Id) {
        const WAPPRStatus = statusList && Array.isArray(statusList)
          ? statusList.filter((status) => status.Status === 'WAPPR')
          : [];
        const StatusId = WAPPRStatus && WAPPRStatus[0] ? WAPPRStatus[0].Id : undefined;
        handleChange(formObject, 'workOrder');
        handleChange(StatusId, 'StatusId');
      }
    };

    fetchData();
  }, []);

  const _getDataById = async () => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/WorkOrderTaskDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      formObject = await getWorkOrderById(base64_decode(path[1]), 'withId');
      _.cloneDeepWith(formObject, (value) => {
        return value !== null && value.StartTime
          ? {
            ...value,
            ...(value['StartTime'] = moment.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
            ...(value['EndTime'] = moment.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
          }
          : _.noop();
      });
    }
    setFormObject(formObject);
    setSelectedJobPlan(formObject && formObject.JobPlanName ? formObject.JobPlanName : '');
    if (formObject && workOrderRef.current) {
      workOrderRef.current.setFieldsValue(formObject);
    }
  };

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length > 0) {
      setFormObject(props.formObject);
    } else {
      setFormObject({});
    }
  }, [props.formObject]);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  // const handleSelect = (value, mainIndex, subindex, keyName) => {
  //   let list = {};
  //   let TaskData = list;
  //   TaskData.map((item, index) => {
  //     if (index === mainIndex) {
  //       item[keyName][subindex]['TotalQuantity'] = value;
  //     }
  //     return {};
  //   });
  // };

  const handleChange = async (value, key) => {
    let formObject = workOrderRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      [key]: value
    };
    if (key === 'Device') {
      let selectedDevice = deviceList.filter((item) => item.AliasCode === value);
      let location = await getLocationByAsset(selectedDevice[0].Asset);
      formObject = {
        ...formObject,
        [key]: value,
        LocationId: location.Name
      };
    }
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onFinish = async (values, key) => {
    let formObject = workOrderRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      [key]: {
        ...formObject[key],
        ...values
      }
    };
    setFormObject(formObject);
    setNoJobplan(true);
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
  };

  const onFormsubmit = async () => {
    let formObject = {
      ...formObject
    };
    if (!formObject.JobPlan) {
      message.info('Please Provide JobPlan Or Task');
    } else if (noJobplan === true) {
      let statusResponse = await submitWorkOrder(formObject);
      if (statusResponse && statusResponse.message) {
        _getDataById();
        message.success('WorkOrder Submitted Successfully');
        props.navigate('/rubus/AMM/WorkOrderList');
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    } else {
      message.error('Please save before you submit the Workorder');
    }
  };

  // const onReset = () => {
  //   workOrderRef.current.resetFields();
  // };

  // const jobPlanOnChange = async (value) => {
  //   let jobplanData = await getJobPlanById(value, 'withoutId');
  //   let formObject = workOrderRef.current.getFieldsValue() || {};
  //   _.cloneDeepWith(jobplanData['TaskData'], (value) => {
  //     return value !== null && value.StartTime
  //       ? {
  //         ...value,
  //         ...(value['StartTime'] = moment.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
  //         ...(value['EndTime'] = moment.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
  //       }
  //       : _.noop();
  //   });
  //   formObject = { ...formObject, JobPlan: jobplanData };
  //   workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
  //   setSelectedJobPlan(value);
  //   setFormObject(formObject);
  // };

  const getValueFromList = (list, compareKey, compareValue, resultKey) => {
    let filterObject = [];
    if (list && Array.isArray(list)) {
      filterObject = list.filter((listObject) => listObject[compareKey] === compareValue);
    }
    return filterObject && filterObject[0] && filterObject[0][resultKey]
      ? filterObject[0][resultKey]
      : '';
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };

  return (
    <>
      <Form
        ref={workOrderRef}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>

        <div
          style={{ color: 'white', margin: '19px 37px', fontWeight: 'bold' }}
        >
          <span style={{ color: '#ffb327' }}>
            {getValueFromList(
              sitesList,
              'Id',
              workOrderRef.current ? workOrderRef.current.getFieldValue('SiteId') : '',
              'Name'
            )}
          </span>{' '}
          (Site)
          <span style={{ margin: '10px' }}> / </span>
          <span style={{ color: '#ffb327' }}>
            {' '}
            {workOrderRef.current ? workOrderRef.current.getFieldValue('LocationId') : null}
          </span>{' '}
          (Location)
          <span style={{ margin: '10px' }}> / </span>
          <span style={{ color: '#ffb327' }}>
            {' '}
            {getValueFromList(
              deviceList,
              'DeviceCode',
              workOrderRef.current ? workOrderRef.current.getFieldValue('Device') : '',
              'Name'
            )}
          </span>{' '}
          (Equipment)
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            borderBottom: '1px dashed white',
            marginBottom: '5px'
          }}
        >
          <Form.Item name="Id"></Form.Item>

          <Form.Item
            label={translation(translationCache, constant.workOrder)}
            name="WorkOrder"
            style={{ width: '100%', flex: '33%' }}
          >
            <div style={{ color: 'white' }}>
              {workOrderRef.current ? workOrderRef.current.getFieldValue('WorkOrder') : null}
            </div>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.description)}
            placeholder={translation(translationCache, 'Input workOrderDescription')}
            name="Description"
            style={{ width: '100%', flex: '33%' }}
            rules={[{ required: true }]}
          >
            <div style={{ color: 'white' }}>
              {workOrderRef.current ? workOrderRef.current.getFieldValue('Description') : null}
            </div>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.status)}
            name="StatusId"
            style={{ width: '100%', flex: '33%' }}
            rules={[{ required: true }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Status')}
              onChange={(value) => handleChange(value, 'StatusId')}
              style={{ width: '30%' }}
            >
              {statusList.map((status, index) => {
                return (
                  <Option key={index} value={status.Id}>
                    {status.Status}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '33%', display: 'none' }}
            name="LocationId"
          ></Form.Item>
          <Form.Item
            label={translation(translationCache, constant.equipment)}
            name="Device"
            style={{ width: '100%', flex: '33%', display: 'none' }}
            rules={[{ required: true }]}
          >
            <div style={{ color: 'white' }}>
              {getValueFromList(
                deviceList,
                'DeviceCode',
                workOrderRef.current ? workOrderRef.current.getFieldValue('Device') : '',
                'Name'
              )}
            </div>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.site)}
            name="SiteId"
            style={{ width: '100%', flex: '33%', display: 'none' }}
            rules={[{ required: true }]}
          >
            <div style={{ color: 'white' }}>
              <div style={{ color: 'white' }}>
                {getValueFromList(
                  sitesList,
                  'Id',
                  workOrderRef.current ? workOrderRef.current.getFieldValue('SiteId') : '',
                  'Name'
                )}
              </div>
            </div>
          </Form.Item>

          <Form.Item
            name="WorkTypeId"
            style={{ width: '100%', flex: '50%', display: 'none' }}
          ></Form.Item>
          <Form.Item
            name="WorkFlowId"
            style={{ width: '100%', flex: '50%', display: 'none' }}
          ></Form.Item>
          <Form.Item
            name="Attachments"
            style={{ width: '100%', flex: '50%', display: 'none' }}
          ></Form.Item>
        </div>

        <Form style={{ padding: '0px' }}>
          <Form.Item name="JobPlan" style={{ width: '100%', flex: '50%' }}>
            {(selectedJobPlan && selectedJobPlan !== undefined && selectedJobPlan !== '') ||
              (formObject['JobPlan'] !== undefined &&
                formObject['JobPlan']['Id'] !== undefined) ? (
              <WorkOrderJobPlanesTask
                noJobplan={false}
                onFinish={onFinish}
                formObject={formObject['JobPlan']}
                fileData={props.fileData}
                workOrderStatus={formObject && formObject.StatusId ? 'CLOSE' : null}
              ></WorkOrderJobPlanesTask>
            ) : null}
            {selectedJobPlan === '' ? (
              <WorkOrderJobPlanesTask
                noJobplan={true}
                onFinish={onFinish}
                formObject={formObject['JobPlan']}
                fileData={props.fileData}
              ></WorkOrderJobPlanesTask>
            ) : null}
          </Form.Item>
        </Form>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WorkOrderDetails);